// extracted by mini-css-extract-plugin
export default {"table":"styles_table__C7esy","express_color":"styles_express_color__MBBR9"};